import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetContractDetailsActon } from "store/actions/ContractActions";
import ProducerDocument from "./producer";
import MusicVideoDocument from "./musicVideo";
import SideArtistDocument from "./sideArtist";
import ArtWorkDocument from "./artWork";
import RemixDocument from "./remix";
import PublishingSplitDocument from "./publishing";
import { useDispatch } from "react-redux";
import ReactQuill from "react-quill";

const Document = ({
  data,
  sign,
  setSign,
  onSignSubmit,
  setCurrentSigner,
  currentSigner,
  handleClear,
  htmlContent,
  setHtmlContent,
  modules,
  formats,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [contractDetails, setContractDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    dispatch(
      GetContractDetailsActon(id, (data) => {
        setContractDetails(data);
        setLoading(false);
      })
    );
  }, [id, dispatch]);

  console.log(contractDetails, "contractDetails");

  const renderDocument = () => {
    switch (data?.agreementType || contractDetails?.payload?.agreementType) {
      case "Producer Agreement":
        return (
          <ProducerDocument
            contractDetails={contractDetails}
            sign={sign}
            setSign={setSign}
            onSignSubmit={onSignSubmit}
            currentSigner={currentSigner}
            setCurrentSigner={setCurrentSigner}
            handleClear={handleClear}
          />
        );
      case "Music Video Agreement":
        return (
          <MusicVideoDocument
            contractDetails={contractDetails}
            sign={sign}
            setSign={setSign}
            onSignSubmit={onSignSubmit}
            currentSigner={currentSigner}
            setCurrentSigner={setCurrentSigner}
            handleClear={handleClear}
          />
        );
      case "Side Artist Agreement":
        return (
          <SideArtistDocument
            contractDetails={contractDetails}
            sign={sign}
            setSign={setSign}
            onSignSubmit={onSignSubmit}
            currentSigner={currentSigner}
            setCurrentSigner={setCurrentSigner}
            setHtmlContent={setHtmlContent}
            htmlContent={htmlContent}
            handleClear={handleClear}
            modules={modules}
            formats={formats}
          />
        );
      case "Artwork Agreement":
        return (
          <ArtWorkDocument
            contractDetails={contractDetails}
            sign={sign}
            setSign={setSign}
            onSignSubmit={onSignSubmit}
            currentSigner={currentSigner}
            setCurrentSigner={setCurrentSigner}
            setHtmlContent={setHtmlContent}
            htmlContent={htmlContent}
            handleClear={handleClear}
            modules={modules}
            formats={formats}
          />
        );
      case "Remix Agreement":
        return (
          <RemixDocument
            contractDetails={contractDetails}
            sign={sign}
            setSign={setSign}
            onSignSubmit={onSignSubmit}
            currentSigner={currentSigner}
            setCurrentSigner={setCurrentSigner}
            handleClear={handleClear}
          />
        );
      case "Publishing Split Form":
        return (
          <PublishingSplitDocument
            contractDetails={contractDetails}
            sign={sign}
            setSign={setSign}
            onSignSubmit={onSignSubmit}
            currentSigner={currentSigner}
            setCurrentSigner={setCurrentSigner}
            handleClear={handleClear}
          />
        );
      default:
        return <div>No document template found for this agreement type</div>;
    }
  };
  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <i className="pi pi-spin pi-spinner text-4xl text-primary" />
        </div>
      ) : (
        renderDocument()
      )}
    </>
  );
};

export default Document;
